import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { CommonStatusTag } from 'components/CommonStatusTag';

import { BundleState } from 'data/__generated__';

import { BUNDLE_STATES_LABELS } from '../constants/states';
import { getColorsFromState } from './StatusTag';

// Small clickable pill showing that a box belongs to a bundle ("Bundle #N · <état>"), linking to the
// bundle. The bundle state is conveyed by color (same mapping as the bundle StatusTag).
export const BundleAssociationTag = ({
    bundleId,
    bundleNumber,
    state,
}: {
    bundleId: string;
    bundleNumber: number;
    state: BundleState;
}) => {
    const { backgroundColor, labelColor } = getColorsFromState(state);

    return (
        <TagLink to={`/bundle/${bundleId}`} onClick={(e) => e.stopPropagation()}>
            <CommonStatusTag
                backgroundColor={backgroundColor}
                labelColor={labelColor}
                label={`Bundle #${bundleNumber} · ${BUNDLE_STATES_LABELS[state]}`}
            />
        </TagLink>
    );
};

const TagLink = styled(Link)`
    text-decoration: none;
    display: inline-flex;
    width: fit-content;

    &:hover {
        opacity: 0.85;
    }
`;
